
import type { ArcChartConfig, Params } from '@empathyco/insights'
import type { PropType } from 'vue'
import type { KpiEnum } from '../enums/kpi.enum'
import { ArcChartComponent } from '@empathyco/insights'

import { defineComponent } from 'vue'
import { EpbText } from './shared/epb-text'

export default defineComponent({
  name: 'KpiArcChart',
  components: { EpbText },
  props: {
    kpi: {
      type: Object as PropType<{
        id: KpiEnum
        label: string
        valueLabel: string
        percentage: number
        count: number
      }>,
      required: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-kpi-arc-chart',
      chart: undefined,
    }
  },
  computed: {
    chartParams(): Params<ArcChartConfig, number> {
      return {
        config: {
          locale: this.$epb.locale,
          transitionsDurationInMillis: 0,
        },
        data: this.kpi.percentage,
      }
    },
    countText(): string {
      return this.$epb.utils.formatNumber(this.kpi.count, { maximumFractionDigits: 2 }, true)
    },
  },
  watch: {
    chartParams: {
      handler(params: Params<ArcChartConfig, number>): void {
        this.chart.update(params)
      },
      deep: true,
    },
  },
  created(): void {
    this.chart = new ArcChartComponent()
  },
  mounted(): void {
    this.chart.init(this.$refs.chart, this.chartParams)
  },
  beforeDestroy(): void {
    this.chart.destroy()
  },
})
